import keyMirror from 'keymirror';

const otpSettingsErrors = keyMirror({
  'ERR.UB.OTP.CRIS_SEND_FAILED': null,
  'ERR.UB.OTP.CRIS_TIMEOUT': null,
  'ERR.UB.OTP.CRIS_VALIDATION_FAILED': null,
  'ERR.UB.OTP.OTPCODE_REDIS_FAILED': null,
  'ERR.UB.OTP.OTPCODE_SAVE_FAILED': null,
  'ERR.UB.OTP.OTPCODE_VALIDATION_FAILED': null,
  'ERR.UB.OTP.OTPTOKEN_REDIS_FAILED': null,
  'ERR.UB.OTP.OTPTOKEN_VALIDATION_FAILED': null,
  'ERR.UB.OTP.POST.RESET_PASSWORD.CRIS_VALIDATION_FAILED': null,
  'ERR.UB.OTP.POST.RESET_PASSWORD.RESET_PASSWORD_ERROR': null,
  'ERR.UB.OTP.POST.RESET_PASSWORD.SAME_AS_OLD': null,
  'ERR.UC.OTP.EMAIL_SEND_FAILED': null,
  'ERR.UC.OTP.INVALID_REQUEST': null,
  'ERR.UC.OTP.NOTIFICATION_SERVICE_NOTAVAILABLE': null,
  'ERR.UC.OTP.OTP_SERVICE_NOTAVAILABLE': null,
  'ERR.UC.OTP.SERVICE_NOTAVAILABLE': null,
  'ERR.UB.OTP.POST.CRIS_TIMEOUT': null,
  'ERR.UB.OTP.POST.INVALID_REQUEST': null,
});

export const otpRecoverPasswordTypeErrors  = [
  otpSettingsErrors['ERR.UB.OTP.CRIS_VALIDATION_FAILED'],
  otpSettingsErrors['ERR.UB.OTP.OTPCODE_VALIDATION_FAILED'],
];

export const recoverPasswordMicroTypeErrors = [
  otpSettingsErrors['ERR.UB.OTP.CRIS_SEND_FAILED'],
  otpSettingsErrors['ERR.UB.OTP.CRIS_TIMEOUT'],
  otpSettingsErrors['ERR.UB.OTP.OTPCODE_REDIS_FAILED'],
  otpSettingsErrors['ERR.UB.OTP.OTPCODE_SAVE_FAILED'],
  otpSettingsErrors['ERR.UB.OTP.OTPTOKEN_REDIS_FAILED'],
  otpSettingsErrors['ERR.UB.OTP.OTPTOKEN_VALIDATION_FAILED'],
  otpSettingsErrors['ERR.UB.OTP.POST.RESET_PASSWORD.CRIS_VALIDATION_FAILED'],
  otpSettingsErrors['ERR.UB.OTP.POST.RESET_PASSWORD.RESET_PASSWORD_ERROR'],
  otpSettingsErrors['ERR.UB.OTP.POST.RESET_PASSWORD.SAME_AS_OLD'],
  otpSettingsErrors['ERR.UC.OTP.EMAIL_SEND_FAILED'],
  otpSettingsErrors['ERR.UC.OTP.INVALID_REQUEST'],
  otpSettingsErrors['ERR.UC.OTP.NOTIFICATION_SERVICE_NOTAVAILABLE'],
  otpSettingsErrors['ERR.UC.OTP.OTP_SERVICE_NOTAVAILABLE'],
  otpSettingsErrors['ERR.UC.OTP.SERVICE_NOTAVAILABLE'],
  otpSettingsErrors['ERR.UB.OTP.POST.CRIS_TIMEOUT'],
  otpSettingsErrors['ERR.UB.OTP.POST.INVALID_REQUEST'],
];